var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[[_c('top-nav',{on:{"changeLanguage":_vm.changeLanguage}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('sider'),_vm._v(" "),_c('div',{staticClass:"right-con"},[_c('followed-pub-account',{ref:"pubacccount"}),_vm._v(" "),_c('router-view')],1)],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-193bbae0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Layout/index.vue
// module id = null
// module chunks = 